var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hound"},[(!_vm.color)?_c('img',{staticClass:"returns",attrs:{"src":require("../../assets/h5/back.png"),"alt":""},on:{"click":_vm.returnBtn}}):_c('img',{staticClass:"returns",attrs:{"src":require("../../assets/h5/back2.png"),"alt":""},on:{"click":_vm.returnBtn}}),_c('p',{style:({
            color: _vm.color
        })},[_vm._v(_vm._s(_vm.text))]),(_vm.historyBtn)?_c('span',{staticClass:"history-btn",on:{"click":_vm.toHistoryPage}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }